import React from 'react'

import { Select } from 'components/Select'

export interface FormSelectProps {
  /**
   * Show a label above the input.
   */
  label?: string
  /**
   * Show a placeholder.
   */
  placeholder?: string
  /**
   * If `true`, the button will be disabled.
   */
  isDisabled?: boolean
  /**
   * Error message.
   */
  errorMessage?: string
  /**
   * If `true`, the select will be required.
   */
  isRequired?: boolean
  /**
   * If `true`, the error message will be shown.
   */
  error?: boolean
  /**
   * If `true`, the input will take up the full width of its container.
   */
  isFullWidth?: boolean
  /**
   * Select options
   */
  options?: SelectOptions[]
  /**
   * Selected option id
   */
  defaultValue?: string
  /**
   * Return selected value as string
   */
  onUserSelect?: (value: string) => void
  /**
   * The html input name
   */
  selectName: string
  /**
   * The html input id
   */
  id: string
}

export const FormSelect = React.forwardRef<HTMLDivElement, FormSelectProps>(
  (props, ref) => {
    const {
      id,
      label,
      isDisabled,
      error,
      isFullWidth,
      errorMessage = 'Error',
      ...rest
    } = props
    const width = isFullWidth ? 'w-full' : 'w-48'

    return (
      <div className="focus-within:text-flamingo-500" ref={ref}>
        <label
          htmlFor={id}
          className={`${width} focus-within:text-flamingo-500 block text-sm z-0 text-dark'
          ${isDisabled && 'text-dark-700'}
          ${error && 'text-flamingo-500'}`}
        >
          {!error ? label : errorMessage}
        </label>
        <Select
          error={error}
          id={id}
          isFullWidth={isFullWidth}
          isDisabled={isDisabled}
          {...rest}
        />
      </div>
    )
  }
)
